import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v1/SmartAi'

const smartAi = {
    StandardPositionList(params) {
        return $http({
            method: 'get',
            url: `${BASEURL}/StandardPosition/List`,
            params
        })
    },
    PositionSetMatchEdit(data) {
        return $http({
            method: 'post',
            url: `${BASEURL}/PositionSetMatch/Edit`,
            data
        })
    },
    PositionSetMatchList(params) {
        return $http({
            method: 'get',
            url: `${BASEURL}/PositionSetMatch/List`,
            params,
        })
    },


}

export default smartAi
